module.exports = __webpack_public_path__ + "static/media/about-us.33da58b3.jpg";